/** @jsxImportSource @emotion/react */
import {
  Popover,
  PopoverPanel,
  PopoverButton,
  PopoverPanelProps,
} from "@headlessui/react";
import { css, SerializedStyles } from "@emotion/react";
import { effects } from "./effects";
import { colors } from "./colors";

export const popoverPanelStyle = css`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  background-color: ${colors.white};
  border-radius: 6px;
  z-index: 1000000000;
  box-shadow: ${effects.popover};
  transform-origin: top;
  transition: transform 100ms ease-out, opacity 100ms ease-out;
  &[data-closed] {
    transform: scale(0.95);
    opacity: 0;
  }
  &::-webkit-scrollbar {
    display: none;
  }
`;

type Props = {
  buttonComponent?: React.ReactNode;
  additionalPanelStyling?: SerializedStyles;
} & PopoverPanelProps;

export const PopoverBase = ({
  children,
  anchor,
  buttonComponent,
  additionalPanelStyling,
  ...rest
}: Props) => {
  return (
    <Popover
      css={css`
        height: 100%;
        position: relative;
      `}
    >
      <PopoverButton
        css={css`
          height: 100%;
        `}
        as="div"
      >
        {buttonComponent}
      </PopoverButton>
      <PopoverPanel
        as="div"
        transition
        css={[popoverPanelStyle, additionalPanelStyling]}
        anchor={anchor || "bottom"}
        {...rest}
      >
        {children}
      </PopoverPanel>
    </Popover>
  );
};
